/**
 * Ajax stuff
 */

(function($){
  var that = {};

  /**
   * General ajax wrapper
   *
   * @param template
   * @param loading
   * @param fn
   * @param additional_data
   */
  that.ajax_general = function (template, loading, fn, additional_data) {

    var data = {
      action: "ajax_general",
      template: template,
      loading: loading,
      post_id: sage_js.post_id,
      blog_id: sage_js.blog_id
    };

    for (var prop in additional_data) {
      if (additional_data.hasOwnProperty(prop)) {
        data[prop] = additional_data[prop];
      }
    }

    var ajax_options = {
      url: sage_js.ajaxurl,
      data: data,
      dataType: "json",
      success: function (response) {
        if (typeof response.status === "undefined" || response.status === "error") {
          console.log("ajax error");
        } else {
          fn(response.data);
        }
      }
    };

    // send some requests to faster ajax.php
    if (loading === "init" && template === "frontpage") {
      ajax_options.url = "/ajax.php";
    }
    if (loading === "reload") {
      ajax_options.url = "/ajax.php";
      ajax_options.cache = true;
      ajax_options.dataType = "json";
      ajax_options.headers = {
        'Cache-Control': 'max-age=10'
      };
    }

    jQuery.ajax(
      ajax_options
    );
  };

  that.frontpage_init = function (data) {
    // Benutzername
    var user = getLibObject("user").getUser();
    if (user) {
      $('#current_user').text(user.display_name);
      $('#user_appendix').show();
    }

    // session merken
    if (typeof data.part === "object" && typeof data.part.thementage_reminder === "object" && typeof data.part.thementage_reminder.status !== "undefined" && data.part.thementage_reminder.status === "success" && typeof data.part.thementage_reminder.thementage !== "undefined") {
      if (data.part.thementage_reminder.thementage.length) {
        var current, form;
        for (var i = 0; i < data.part.thementage_reminder.thementage.length; i++) {
          current = wp.hooks.applyFilters( 'netconSaveTheSessionRememberButton', data.part.thementage_reminder.thementage[i]);
          form = $("form[data-session=" + current.id + "]");
          form.find(".btn")
            .text(current.caption).removeClass("btn-primary")
            .removeClass("btn-default").removeClass("disabled").addClass(current.btn_class);
          form.find("input[name=subscribe]").val(current.user_saved_the_session ? "0" : "1");
        }
      }
    }

    // alle merken
    if (typeof data.part === "object" && typeof data.part.thementage_reminder_all === "object" && typeof data.part.thementage_reminder_all.status !== "undefined" && data.part.thementage_reminder_all.status === "success" && typeof data.part.thementage_reminder_all.frontpage !== "undefined") {
      if (typeof data.part.thementage_reminder_all.frontpage.id !== "undefined") {
        var current2, form2;
        current2 = wp.hooks.applyFilters( 'netconSaveTheDateAllRememberButton', data.part.thementage_reminder_all.frontpage);
        form2 = $("#save_the_date");
        form2.find(".btn")
          .text(current2.caption).removeClass("btn-primary")
          .removeClass("btn-default").removeClass("disabled").addClass(current2.btn_class);
        form2.find("input[name=subscribe]").val(current2.user_saved_the_session ? "0" : "1");
      }
    }
  };

  that.single_thementag_init = function (data) {
    if (typeof AJAX_RELOAD_DEBUG !== "undefined" && AJAX_RELOAD_DEBUG) {
      console.log(data);
    }
  };

  that.user_fragen_reload = function (data) {

    var zuschauer_parent = $("#zuschauer-bubbles").find(".bubble-container");
    var single_zuschauer;
    var deleted_comments = false;

    // comments
    // these comments should be a list of the comments should be able to grow, top5, only selected from dashboard or all?
    if (typeof data.part.reload_comments !== "undefined") {
      var reload_comments = data.part.reload_comments;

      if (reload_comments.status === "success") {
        if (typeof reload_comments.comments !== "undefined") {

          reload_comments.comments = getLibObject("helper").shuffleArray(reload_comments.comments);

          // comment fields:
          /*
            comments[k].comment_id,
            comments[k].user_id,
            comments[k].timestamp_unix,
            comments[k].comment_initials,
            comments[k].comment_author,
            comments[k].comment_karma,
            comments[k].timestamp_iso,
            comments[k].timestamp_formated,
            comments[k].comment_content,
            comments[k].comment_vimeo_timestamp
          */

          // add class to bubble if user asked a question
          $.each(reload_comments.comments,function(index, comment_object){
            var user_bubble = zuschauer_parent
              .find("[data-user-id=" + comment_object.user_id + "]")
              .filter("[data-comment-id=" + comment_object.comment_id + "]");

            if(!user_bubble.length) {
              // create user bubble for this comment
              single_zuschauer = getLibObject('config').ajax_templates.zuschauerComment;
              comment_object.comment_content = getLibObject('comments').replaceSmileys(comment_object.comment_content);
              single_zuschauer = single_zuschauer
                .replaceAll("%%USERID%%", comment_object.user_id)
                .replaceAll("%%POPUPID%%", "popup-" + comment_object.user_id + "-" + comment_object.comment_id )
                .replaceAll("%%COMMENTID%%", comment_object.comment_id)
                .replaceAll("%%VOTECOUNT%%", comment_object.comment_karma)
                .replaceAll("%%USERINITIALS%%", comment_object.comment_initials)
                .replaceAll("%%USERNAME%%", comment_object.comment_author + " fragt:")
                .replaceAll("%%COMMENTTIME%%", comment_object.timestamp_formated)
                .replaceAll("%%COMMENTMESSAGE%%", comment_object.comment_content)
                .replaceAll("%%CLASS%%", "new-element");

              zuschauer_parent.append(single_zuschauer);
            } else {
              // check if vote updated
              if(user_bubble.attr("data-votecount") !== "" + comment_object.comment_karma ) {
                user_bubble.attr("data-votecount",comment_object.comment_karma);
                user_bubble.addClass("vote-updated");
              }
            }
          });

          // look for comments that are no longer in response
          var bubbles_to_delete = zuschauer_parent.find("[data-comment-id]");
          $.each(reload_comments.comments,function(index, comment_object){
            bubbles_to_delete = bubbles_to_delete.not("[data-comment-id=" + comment_object.comment_id + "]");
          });
          if(bubbles_to_delete.length) {
            deleted_comments = true;
            bubbles_to_delete.remove();
          }

          // add additional bubble to bubbles if user has more than 1 question
        }
      }
    }

    // zuschauer
    if (typeof data.part.zuschauer !== "undefined") {
      var zuschauer = data.part.zuschauer;

      if (zuschauer.status === "success") {

        if (zuschauer.zuschauer.length) {
          var zuschauer_child;

          // to simulate more users for dev:
          if(getLibObject("config").simulateZuschauerBubbles) {
            for (var i = 0; i < 6; i++) {
              zuschauer.zuschauer = zuschauer.zuschauer.concat(JSON.parse(JSON.stringify(zuschauer.zuschauer)));
            }
          }

          // add zuschauer bubbles if they have no comment
          $.each(zuschauer.zuschauer,function(index, zuschauer_object){
            var user_bubble = zuschauer_parent
              .find("[data-user-id=" + zuschauer_object.ID + "]");

            if(!user_bubble.length) {
              // create user bubble for this comment
              single_zuschauer = getLibObject('config').ajax_templates.zuschauerComment;
              single_zuschauer = single_zuschauer
                .replaceAll("%%USERID%%", zuschauer_object.ID)
                .replaceAll('data-comment-id="%%COMMENTID%%', "")
                .replaceAll('data-votecount="%%VOTECOUNT%%"', "")
                .replaceAll("%%POPUPID%%", "popup-" + zuschauer_object.ID + "-x" )
                .replaceAll("%%USERINITIALS%%", zuschauer_object.display_name)
                .replaceAll("%%USERNAME%%", "")
                .replaceAll("%%COMMENTTIME%%", "")
                .replaceAll("%%COMMENTMESSAGE%%", "")
                .replaceAll("%%CLASS%%", "new-element");

              zuschauer_parent.append(single_zuschauer);
            }
          });
        }
      }
    }


    if(!getLibObject("dots").DotsUserQuestions.isInit) {
      zuschauer_parent.on('click',".bubble",function(e){ // should also work for new bubbles this way
        e.preventDefault();
        if($(this).attr("data-comment-id")) {
          $.fancybox.open([
            {href: $(this).attr("href")}
            ],{
            wrapCSS: "user-fragen",
            minWidth: 600,
            minHeight: 200,
            maxWidth: "80%",
            maxHeight: "80%",
            arrows: false,
            closeBtn: false,
            helpers : {
              overlay : {
                css : {
                  'background' : 'transparent'
                }
              }
            },
            padding: ["25px","30px","25px","30px"]
          });
        }
      });
      getLibObject("dots").DotsUserQuestions.init('.bubble-container', '.bubble', {});
      getLibObject("dots").DotsUserQuestions.start();
      getLibObject("dots").DotsUserQuestions.isInit = true;
      zuschauer_parent.find(".new-element").removeClass("new-element");
      zuschauer_parent.find(".vote-updated").removeClass("vote-updated");
    } else {
      var new_elements = zuschauer_parent.find(".new-element");
      var updated_elements = zuschauer_parent.find(".vote-updated");
      var all_voted_elements = zuschauer_parent.find("[data-votecount]");

      getLibObject("dots").DotsUserQuestions.updateCache();
      if(updated_elements.length || deleted_comments || new_elements.length) {
        getLibObject("dots").DotsUserQuestions.update(all_voted_elements); // first change size
      }
      if(new_elements.length) {
        getLibObject("dots").DotsUserQuestions.add(new_elements); // then add new
      }
      new_elements.removeClass("new-element");
      updated_elements.removeClass("vote-updated");
    }

  };

  that.single_thementag_reload = function (data) {
    getLibObject("helper").log("single_thementag_reload data");
    getLibObject("helper").log(data);
    var pollDeactivateQuestionBox = false;
    if (typeof AJAX_RELOAD_DEBUG !== "undefined" && AJAX_RELOAD_DEBUG) {
      console.log(data);
    }
    // poll
    if (typeof data.part.reload_poll !== "undefined") {
      var dataPoll = data.part.reload_poll;
      if (dataPoll.status === "success") {
        var new_poll = dataPoll.content;
        $('#poll').empty().html(new_poll);
        getLibObject("poll").pollVotingHander();
        $('#player').addClass("poll-visible");
        pollDeactivateQuestionBox = true; // disable comments temporarily
        if (typeof AJAX_RELOAD_DEBUG !== "undefined" && AJAX_RELOAD_DEBUG) {
          console.log("thementag_reload: poll");
          console.log(dataPoll);
        }
      } else {
        $('#player').removeClass("poll-visible");
      }
    } else {
      $('#player').removeClass("poll-visible");
    }

    // showstream
    if (typeof data.part.current_time !== "undefined") {
      if (data.part.current_time.status === "success") {
          $('#player').attr("data-currentTime",data.part.current_time.current_time);
      }
    }

    // show_comments
    if (typeof data.part.show_comments !== "undefined") {
      var show_comments = data.part.show_comments;
      if (show_comments.status === "success") {
        var preDate = new Date($('#countdown-timer').attr("datetime"));
        preDate.setMinutes(preDate.getMinutes() - getLibObject("config").commentActivateOffsetMinutes);
        var now = new Date();
        var activate = ( $('#countdown-timer').length < 1 || typeof preDate === "object" && preDate <= now);

        if (show_comments.show === '1' && activate && !pollDeactivateQuestionBox) {
          getLibObject("countdown").activateQuestionBox();
        } else {
          getLibObject("countdown").deactivateQuestionBox();
        }
        if (show_comments.show === '1') {
          getLibObject("comments").enableCommentTab();
        } else {
          getLibObject("comments").disableCommentTab();
        }
        if (typeof AJAX_RELOAD_DEBUG !== "undefined" && AJAX_RELOAD_DEBUG) {
          console.log("thementag_reload: showcomments");
        }
      }
    }

    // comments
    if (typeof data.part.reload_comments !== "undefined") {
      var reload_comments = data.part.reload_comments;
      if (reload_comments.status === "success") {
        $("#zuschauer-reload").detach();

        if (typeof reload_comments.comments !== "undefined") {
          var commentsContainerElement = $("#comments");
          var scrollTop = commentsContainerElement.scrollTop();
          var parent = commentsContainerElement.find(">ol");

          getLibObject("comments").insertComments(data.part.reload_comments.comments, parent);

          commentsContainerElement.scrollTop(scrollTop);
        }

        getLibObject("comments").onCommentReload();

        if (typeof reload_comments.comments_top5 !== "undefined" && reload_comments.comments_top5.length) {

          var comments2 = $("#comments-top5");
          var scrollTop2 = comments2.scrollTop();
          var parent2 = comments2.find(">ol");
          getLibObject("comments").insertCommentsTop5(reload_comments.comments_top5, parent2);
          //comments2.scrollTop(scrollTop2);
        }

        getLibObject("comments").onTop5Reload();

        if (typeof AJAX_RELOAD_DEBUG !== "undefined" && AJAX_RELOAD_DEBUG) {
          console.log("thementag_reload: comments");
        }
      }
    }

    // zuschauer
    if (typeof data.part.zuschauer !== "undefined") {
      var zuschauer = data.part.zuschauer;
      if (zuschauer.status === "success") {
        var single_zuschauer;
        if (zuschauer.zuschauer.length) {
          var zuschauer_parent = $("#zuschauer").find(".bubble-container");
          var zuschauer_child,
            currentUser = getLibObject("user").getUser();
          if (currentUser) {
            zuschauer.zuschauer.filter(function (user) {
              return user.ID !== currentUser.ID;
            }).unshift(currentUser);
          }
          // to simulate more users for dev:
          if(getLibObject("config").simulateZuschauerBubbles) {
            for (var i = 0; i < 6; i++) {
              zuschauer.zuschauer = zuschauer.zuschauer.concat(JSON.parse(JSON.stringify(zuschauer.zuschauer)));
            }
          }

          for (var n = 0; n < zuschauer.zuschauer.length; n++) {
            // dev call for different ids
            if(getLibObject("config").simulateZuschauerBubbles) {
              zuschauer.zuschauer[n].ID = zuschauer.zuschauer[n].ID * (n + 10);
            }

            single_zuschauer = ajax_templates.zuschauer;
            single_zuschauer = single_zuschauer
              .replaceAll("%%USERID%%", zuschauer.zuschauer[n].ID);

            if (zuschauer.zuschauer[n].online_moderator) {
              single_zuschauer = single_zuschauer
                .replaceAll("%%USERINITIALS%%", "")
                .replaceAll("%%ROLECLASS%%", "online-moderator");
            } else if (zuschauer.zuschauer[n].twitter_reporter) {
              single_zuschauer = single_zuschauer
                .replaceAll("%%USERINITIALS%%", "")
                .replaceAll("%%ROLECLASS%%", "twitter-reporter");
            } else if (zuschauer.zuschauer[n].fachexperte) {
              single_zuschauer = single_zuschauer
                .replaceAll("%%USERINITIALS%%", "")
                .replaceAll("%%ROLECLASS%%", "fachexperte");
            } else {
              single_zuschauer = single_zuschauer
                .replaceAll("%%USERINITIALS%%", zuschauer.zuschauer[n].display_name)
                .replaceAll("%%ROLECLASS%%", "");
            }

            zuschauer_child = zuschauer_parent.find("[data-user-id=" + zuschauer.zuschauer[n].ID + "]");
            if (zuschauer_child.length === 0) {
              zuschauer_parent.append(single_zuschauer);
              zuschauer_child = zuschauer_parent.find("[data-user-id=" + zuschauer.zuschauer[n].ID + "]");
            } else {
            }
            zuschauer_child.addClass("keep");
          }
          zuschauer_parent.find(">li").not(".keep").remove();
          zuschauer_parent.find(">li").removeClass("keep");

          var tmp_count = "";
          if (zuschauer.zuschauer_count.length) {
            tmp_count = zuschauer.zuschauer_count;
          } else {
            tmp_count = $("#zuschauer").find(".bubble-container").find(">li").length;
          }

          if (tmp_count !== "") {
            $("#zuschauer-reload").attr("data-zuschauer-count", tmp_count);

            var element = $("#zuschauer");
            element.find(".user-counter").removeClass("hide").hide();
            element.find(".counter").text(tmp_count);
            if (tmp_count === "1") {
              element.find(".user-counter.single").show();
            } else {
              element.find(".user-counter.multi").show();
            }
          }
          getLibObject("comments").refreshZuschauer();

          getLibObject("dots").DotsReplacementEliptic.init('.bubble-container', '.bubble', {});
          getLibObject("dots").DotsReplacementEliptic.start();
          getLibObject("comments").loadPopupsFromComments();
        }
      }
    }

    // feedback
    if (typeof data.part.feedbackform !== "undefined") {
      var feedbackform = data.part.feedbackform;
      if (feedbackform.status === "success") {
        var formActivate = feedbackform.activate;
        var formUrl = feedbackform.url;
        var formUrlDom = $(".feedback-form-url");
        if (formUrlDom.length) {
          formUrl = formUrlDom.attr("href");
        }
        if (formActivate) {
          if (!window.feedbackFormWasActive) {
            $.fancybox(
              '<div id="feedback_popup"><h4>Bitte geben Sie uns Ihr Feedback zur heutigen Veranstaltung</h4><br>' +
              '<div><a href="' + formUrl +
              '" target="_blank" class="btn btn-primary more">ZUR BEFRAGUNG</a></div>' +
              '</div>', {
                width: 250,
                maxWidth: 250,
                minWidth: 250,
                autoSize: false,
                autoHeight: true,
                leftRatio: 0.9,
                helpers: {
                  overlay: null
                }
              });
            window.feedbackFormWasActive = true;
          }
        }

        var feedbackSection = $("#feedback");
        var feedbackHighlight = $("#scrollspy-menu").find("a[href='#feedback']").parent();
        if (feedbackform.showFeedbackSection) {
          // show section
          feedbackSection.removeClass("hide");
          feedbackHighlight.show();
        } else {
          // hide section
          feedbackSection.addClass("hide");
          feedbackHighlight.hide();
        }
      }
    }
  };

  that.kontakt_init = function (data) {
    var input_name = $("#input_1_1");
    var input_email = $("#input_1_3");
    if (input_name.length && data.template === "template_kontakt" && typeof data.part !== "undefined" && typeof data.part.user !== "undefined" && typeof data.part.user.firstname !== "undefined" && typeof data.part.user.lastname !== "undefined") {
      if (input_name.val() === "" && input_email.val() === "") {
        input_name.val(data.part.user.firstname + " " + data.part.user.lastname);
        input_email.val(data.part.user.email);
      }
    }
  };

  window.vrnetworld.ajax = that;
})(jQuery);
